/* InsightsFilter.ts */

/* Interfaces */
import { CustomFeature } from "src/shared/constants/common/CustomFeature";

export enum FilterType {
  MAIN_CONDITION = "mainCondition",
  FEATURES = "features",
  COHORTS = "cohorts",
  TIME_PERIOD = "timePeriod",
  CUSTOM_FEATURES = "customFeature",
  CARE_SITES = "careSites",
}

export enum FilterComponentType {
  DROPDOWN = "dropdown",
  SLIDER = "slider",
  MULTI_SELECT = "multiSelect",
}

export enum TimePeriodType {
  FIRST_YEAR = "firstYear",
  LAST_YEAR = "lastYear",
}

export interface InsightsFilterProps {
  mainCondition: MainConditionFilterProps<string>;
  features: FilterProps<string>;
  cohorts: FilterProps<string>;
  timePeriod?: FilterProps<Partial<TimePeriodProps>>;
  customFeature?: FilterProps<CustomFeature>;
  careSites?: FilterProps<string[]>;
}

export interface MainConditionFilterProps<T = string> {
  value?: T | null;
  initialValue?: T | null;
  previousValue?: T extends TimePeriodProps
    ? Partial<T>
    : T;
  items?: string[];
  isInitialized?: boolean;
  disabled?: boolean;
  show?: boolean;
  componentType?: FilterComponentType;
  isLoading?: boolean;
}

export interface FilterProps<
  T = string | CustomFeature | TimePeriodProps
> {
  value?: T;
  initialValue?: T;
  previousValue?: T extends TimePeriodProps
    ? Partial<T>
    : T;
  items?: string[] | CustomFeature[];
  isInitialized?: boolean;
  /**
   * Set once the value has been chosen deliberately — by the user or
   * by an applied agent spec — so a late-resolving options fetch does
   * not overwrite it. Cleared when the main condition changes.
   * Currently only meaningful for `timePeriod`.
   */
  isExplicitlySet?: boolean;
  disabled?: boolean;
  show?: boolean;
  componentType?: FilterComponentType;
  isLoading?: boolean;
}

export interface TimePeriodProps {
  firstYear: string;
  lastYear: string;
}
